import Expenses from "./components/Categories/Expenses";
import Expenses2 from "./components/Categories/Expenses2";
import Expenses3 from "./components/Categories/Expenses3";
import Expenses4 from "./components/Categories/Expenses4";
import Expenses5 from "./components/Categories/Expenses5";
import "./maincss.css"



function App() {


  const expenses = [
    {
      id: "e1",
      heading: "BACKLOG",
      title: "NEW TITLE",
      account: "Makro",
      desc: "Some Random Data To Be Entered Acting As a description of the card",
      amount: 20,
      date: new Date(2020, 7, 14),
    },
    {
      id: "e2",
      heading: "ANALYSIS",
      title: "ADM APPLICATION",
      account: "Pep & PepKor",
      desc: "Some Random Data To Be Entered Acting As a description of the card",
      amount: 5,
      date: new Date(2021, 2, 12),
    },
    {
      id: "e3",
      heading: "DOING",
      title: "A LONGER HEADING TITLE",
      account: "Nedbank",
      desc: "Some Random Data To Be Entered Acting As a description of the card",
      amount: 60,
      date: new Date(2021, 2, 28),
    },
    {
      id: "e4",
      heading: "TESTING",
      title: "NEW CARD TITLE",
      account: "MassMart",
      desc: "Some Random Data To Be Entered Acting As a description of the card",
      amount: 29,
      date: new Date(2021, 5, 12),
    },
    {
      id: "e5",
      heading: "DONE",
      title: "DRAG AND DROP",
      account: "MassCash",
      desc: "Some Random Data To Be Entered Acting As a description of the card",
      amount: 29,
      date: new Date(2021, 5, 12),
    },
    {
      id: "e5",
      heading: "Done",
      title: "NEW TITLE WITH EXTRA",
      account: "Makro",
      desc: "Some Random Data To Be Entered Acting As a description of the card",
      amount: 29,
      date: new Date(2021, 5, 12),
    },
    {
      id: "e5",
      heading: "Done",
      title: "SOME TITLE FOR NEW DATA",
      account: "Barloworld",
      desc: "Some Random Data To Be Entered Acting As a description of the card",
      amount: 75,
      date: new Date(2021, 5, 12),
    },
    {
      id: "e7",
      heading: "Done",
      title: "ANOTHER TITLE",
      account: "Makro",
      desc: "Some Random Data To Be Entered Acting As a description of the card",
      amount: 23,
      date: new Date(2021, 6, 9),
    },
  ];

  return (
    <div className="main">
      <Expenses expenses={expenses} />
      <Expenses2 expenses={expenses} />
      <Expenses3 expenses={expenses} />
      <Expenses4 expenses={expenses} />
      <Expenses5 expenses={expenses} />
    </div>
  );
}

export default App;
